import { createModal } from '/@/core/elements/modal'

interface PaletteDetailModalData {
  paletteId: string | null
}
const { api, component } = createModal<PaletteDetailModalData>(
  'PaletteDetailModal',
  () => import('./PaletteDetailModal.vue'),
  {
    paletteId: null,
  },
)

export const usePaletteDetailModal = api
export default component
